<script lang="ts">
	import type { LocalizedString } from "../../../core/schema/Locale";
	import { getGlobalSettings } from "../getGlobalSettings";
	import plus from "../../../core/assets/icons/plus.svg?raw";
	import minus from "../../../core/assets/icons/minus.svg?raw";
	import Icon from "./Icon.svelte";
	import Content from "./Content.svelte";

	export let question: LocalizedString;
	export let answer: LocalizedString;
	export let anchor: LocalizedString;
	export let isOpen: boolean;
	export let onClick: () => void;

	const { TENANT_LOCALE } = getGlobalSettings();

	/* eslint-disable svelte/no-at-html-tags */
</script>

<div
	class="border-grey-200 flex flex-col items-center rounded-[1.375rem] border transition-colors duration-300"
	id={anchor[TENANT_LOCALE]}
>
	<button on:click={onClick} class="flex w-full items-center justify-between gap-6 px-6 py-[1.62rem]">
		<h2 class="md:text-md text-secondary m-0 w-full text-start text-xs font-semibold leading-5 md:leading-7">
			{question[TENANT_LOCALE]}
		</h2>
		<Icon icon={isOpen ? minus : plus} class="h-8 w-8" />
	</button>
	{#if isOpen}
		<div class="mb-[0.38rem] w-full px-6 pb-[1.62rem]">
			<Content content={answer[TENANT_LOCALE]} class="faq-ckeditor" />
		</div>
	{/if}
</div>

<style lang="postcss" global>
	.faq-ckeditor .ckeditor-content p {
		@apply m-0 !text-start text-xs !leading-6 md:!text-base;
	}
</style>
